<template>
    <div class="content rank-details">
        <!-- 开奖彩果 -->
        <div class="row-item result-content" v-if="resultFlag">
            <div class="row-item-left">
                <input v-for="( item, index ) in data.result" :key="index" class="item-btn selection" :class="{'blueBallz': index > 5}" type="button" :value="item" />
            </div>
        </div>
        <template v-else>
            <!-- 投注项 -->
            <div class="row-item" v-for="( item,index ) in data.selectContent" :key="`row-${index}`" :class="{ 'no-first-row': index != 0 }">
                <div class="row-item-left">
                    <div v-if="allPlan.length > 0 && allPlan[index].detail.bravery && allPlan[index].detail.bravery.length > 0" class="dan-list">
                        <span>胆 :&nbsp; </span> 
                        <input class="item-btn" :class="{'selection': result.length == 0 || result.includes( item1 + '')}" v-for="( item1, index1 ) in allPlan[index].detail.bravery" type="button" :value="item1" :key="index1" />
                        <span>拖 :&nbsp; </span> 
                    </div>
                    <div class="flex flex-wrap" v-for="( item2, index2 ) in item" :key="index2">
                        <div class="flex-align" v-for="( item3, index3 ) in item2" :key="index3">
                            <input class="item-btn selection" v-if="!data.result" :class="{ 'blueBallz': index2 > 5 }" type="button" :value="item3" />
                            <input class="item-btn" v-else
                                :class="{'selection': data.order_info.prize_cash == 0 ? true : (['3-3', '3-6', '31'].includes( rankZuType ) ? result.includes( item3 + '' ) : (['32', '3_32'].includes( rankZuType ) ? getRes(result, item3) : rankZuType == '3_31' ? getResZ3(result, item3, index3, item2) : item3 == result[ index2 ])), 'blueBall' : index2 > 5, 'blueBallz' : index2 > 5 && (item3 == result[ index2 ]) }" type="button" :value="item3" />
                            <div class="solid" v-if="index3 === item2.length - 1 && index2 != item.length - 1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script scoped>
    export default {
        props: [ 'row', 'isLottery', 'data', 'resultFlag', 'rankZuType' ],
        data(){
            return{
                result: [],
                allPlan: []
            }
        },
        
        mounted(){
            console.log('mounted', this.data, this.rankZuType)
            if(this.data.result) this.result = this.data.result.map((item) => item + '')
            if(this.rankZuType == 31 || this.rankZuType == '3-3' || this.rankZuType == '3-6' ) this.allPlan = this.data.plan_detail[0].content
        },
        methods: {
            sortFn ( a, b ) {
                return a - b;
            },
            getResZ3(res, item, index, item2){
                // console.log('res', res.sort(this.sortFn), item, index, item2.sort(this.sortFn) )
                let isCo = false
                // 是组三
                if(res[0] == res[1] || res[0] == res[2] || res[1] == res[2]){
                    // 两个数字相同  从小到大排序变成字符串然后对比
                    let st1 = res.sort(this.sortFn).join()
                    let st2 = item2.sort(this.sortFn).join()
                    if(st2 == st1) isCo = true
                    else{
                        if( index == 1) return false
                        isCo = res.includes( item + '' )
                    }                    
                }else{
                    if( index == 1) return false
                    isCo = res.includes( item + '' )
                }
                return isCo
            },
            getRes(res, item){
                // 组三单式
                let tol1 = 0
                res.map((item1) => tol1 += Number(item1) )
                return tol1 == item
            }
        },
    };
</script>

<style lang="less" scoped>
    @import '~@/assets/css/common.less';
    @margin10px: 10px;
    .content {
        .m( 0 -17px );
        .row-item {
            .d-f-c( row, flex-start, center );
            border-bottom:solid 1px #d7e1f0;
            // border-bottom:1px solid rgba(60, 69, 78, 0.8); 
            &-left {
                .d-f-c( row, flex-start, center ); .p( 0 16px );
                .solid {
                    .w( 2px ); .h( 22px ); .bg( #BE0B00 ); .bor( 1px ); opacity:1; .m( -@margin10px 4px 0 4px );
                }
                .item-btn {
                    .mb( @margin10px );.w( 25px );.h( 25px );.mr( 2px ); .bg( #fff );
                }
            }
            &.no-first-row {
                .bd-t( 1px, solid, #e8eaec ); .pt( @margin10px );
            }
            &.result-content {
                justify-content: center;
                .item-btn {
                    .mr( 8px );
                }
            }
        }
        .row-item:nth-child(5n){
            border-bottom:2px solid rgba(60, 69, 78, 0.8);
        }
        .row-item:last-child{
            border-bottom:0;
        }
        .item-btn {
            .bor( 50% ); .h( 36px ); .w( 36px ); .bd( 1px, solid, #FFCDCD ); .fz( 14px ); .fw( 600 );
            .c( #BE0B00 ); .mr( 10px );
            &.first-row{
                .mb( 10px );
            }
            &.selection{
                .bg( #BE0B00 ); .c; border-color: #BE0B00;
            }
        }
    }
    .spzhi{
      .content .row-item-left .item-btn{
          margin-bottom: 0;
      }
    }
    .content .item-btn.blueBall{ background-color: #ffffff; border-color: #002BB9; color: #002BB9; }
    .content .item-btn.blueBallz{ background-color: #002BB9; border-color: #002BB9; color: #ffffff; }
</style>